"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Remove = (props) => {
    const { width = '32px', height = '32px', color = '#111' } = props;
    return (React.createElement(react_native_svg_1.Svg, Object.assign({ width: width, height: height }, props),
        React.createElement(react_native_svg_1.G, { fill: "none", fillRule: "evenodd" },
            React.createElement(react_native_svg_1.Path, { d: "M0 0h32v32H0z" }),
            React.createElement(react_native_svg_1.Path, { d: "M22 10 10 22m12 0L10 10", strokeLinecap: "square", stroke: color }))));
};
exports.default = Remove;
